import React, {useState, useEffect} from "react";
// Styles
import "./rwlc.style.css";
// Actions
import { Base_API } from '../../_actions/matcher'
// Images
import RewardImg from "../../assets/images/rewards/reward_1.png";
import RightFullIcon from '../../assets/images/icons/rightfull.png'

function RewardList_Card({ data, onSelected }) {

    return (
        <div className="rwlc-container" onClick={() => onSelected(data.id)}>
            <img   
                className={data.isRedeem === false ? `rw-img full` : `rw-img`} 
                src={data.Cover} 
            />
            <div className="dt-wrap">
                {/* reward name */}
                <h4 className="name">{data.Title}</h4>
                <p className="desc">{data.description}</p>
                <span className="point">
                    <span>{Number(data.redeemPoint).toLocaleString('th')}</span> คะแนน
                </span>
            </div>

            {data.isRedeem === false &&
                <img src={RightFullIcon} 
                    className="rghtfll-icon"
                /> 
            }
        </div>
    );
}

export default RewardList_Card;
